import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, StyleSheet, TextInput, TouchableOpacity } from 'react-native';

import { navigate } from '../../../../navigation/RootNavigation';
import { TenantService } from '../../redux/tenant.service';
import PropertyCard from './components/PropertyDetailsCard';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import { Tab, TablePagination } from '@material-ui/core';
import ajax from '../../../../helpers/ajaxHelper';
import Urls from '../../../../services/Urls';
import { showErrorToast } from '../helpers';
import { useDispatch } from 'react-redux';
import HorizontalTabSliderWelcome from './components/HorizontalTabSliderWelcome';
import { useIsFocused } from '@react-navigation/native';
import Pagination from '@mui/material/Pagination'
import getPlatformType from '../../../../helpers/helpers';
const ArchivedOnboards = (props) => {
    const [count, setCount] = useState([]);
    const [pageSize, setPageSize] = useState(10)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState('');
    const layout=getPlatformType();

    const pageCount = Math.ceil(total / pageSize)
    const [debounceSearch, setDebounceSearch] = useState('')
    const [flows, setFlows] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        TenantService.getCount().then((response) => {
            console.log("getCount,", response)
            if (response && response?.data && response?.data?.length) {
                setCount(response?.data)
            }
        });
    }, []);
    const fetchTableData = useCallback(async () => {
        const filters = {
            pageNo: page - 1,
            search: debounceSearch,
            sortBy: "createdAt",
            sortOrder: "desc",
        }
        ajax.get(Urls.getArchivedFlows, { params: filters }).then(({ data }) => {
            console.log("datadata", data)
            if (data.status) {
                if (data?.data.flows?.length > 0) {
                    setFlows(data?.data?.flows)
                    setTotal(data?.data?.totalFlows)
                    //   setPageSize(data?.data?.pageSize)
                } else {
                    setFlows([])
                    setTotal(0)
                }
            } else {
                showErrorToast(data.message)
            }
        }
        )
    }
    )
    const focused = useIsFocused();
    useEffect(() => {
        fetchTableData()
    }, [page, debounceSearch,focused])
    const handlePageClick = (data) => {
        console.log('onPageChange', data);
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        // this.setState({ offset: offset }, () => {
        //   this.loadCommentsFromServer();
        // });
    };
    useEffect(() => {
        const delayInputTimeoutId = setTimeout(() => {
            setPage(1)
            setDebounceSearch(search)
        }, 500)

        return () => clearTimeout(delayInputTimeoutId)
    }, [search])
    const handlePageChange = (event, value) => {
        setPage(value)
    }
    const handleRowPageChange = (e) => {
        setPageSize(e.target.value)
    }
    const handleFilter = (value) => {
        setSearch(value)
    }
    return (
        <>
            <HorizontalTabSliderWelcome props={props} />
            <View style={styles.container}>
                <Text style={styles.welcomeTitle}>
                Archived Onboards</Text>
                <Text style={styles.welcomeText}>
                Below is a list of archived onboards.
                </Text>
                <View style={{ flexDirection:layout=="phone"?'column' :'row',gap:12 ,marginBottom: 10, justifyContent: 'space-between' }}>
                    <TextInput
                        style={styles.searchInput}
                        placeholder="Search"
                        value={search}
                        onChangeText={handleFilter}
                    />
                    <TouchableOpacity
                        style={[styles.button2, { opacity: 1 }]}
                        onPress={() => navigate("addproperty")}
                    >
                        <Text style={styles.buttonText2}>+ NEW MOVE IN</Text>
                    </TouchableOpacity>
                </View>
                <Text style={styles.welcomeTitl2}>
                Total matching records: {total}</Text>
                <View style={{ flexDirection: "row", flexWrap: 'wrap' }}>

                    {flows && flows.length ?
                        flows.map((item, index) => {
                            return (

                                <PropertyCard
                                    item={item}
                                    index={index}
                                    onRefresh={()=>fetchTableData()}
                                />
                            )
                        }) : null}
                </View>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
<Pagination count={pageCount} page={page} onChange={handlePageChange} color='primary' />
</View>
            </View>
        </>
    );
};



const styles = StyleSheet.create({
    welcomeTitl2: {
        fontSize: 16,
        fontWeight: '600',
        color: '#7C3AED',
        marginBottom: 20,
        marginTop:10,
        alignSelf:"flex-end"
    },
    searchInput: { borderWidth: 1, padding: 8, borderRadius: 5, borderColor: "#ccc", flex: 1 },
    container: {
        padding: 20,
        backgroundColor: '#F9FAFB',
        marginVertical: 30,
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 3,
        marginBottom: 20,
    },
    statsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: 20,
    },
    statCard: {
        width: '48%',
        padding: 15,
        borderRadius: 10,
        alignItems: 'center',
        marginBottom: 10
    },
    statIcon: {
        marginBottom: 8,
    },
    statValue: {
        fontSize: 22,
        fontWeight: 'bold',
        color: '#374151',
    },
    statLabel: {
        fontSize: 14,
        color: '#1F2937',
    },
    notificationCard: {
        backgroundColor: '#FEF3C7',
        padding: 15,
        borderRadius: 10,
        marginBottom: 20,
    },
    notificationTitle: {
        fontWeight: 'bold',
        fontSize: 16,
        color: '#92400E',
        marginBottom: 10,
    },
    notificationMessage: {
        fontSize: 14,
        color: '#374151',
    },
    welcomeContainer: {
        backgroundColor: '#FFFFFF',
        padding: 20,
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 3,
        marginBottom: 20,
        marginTop: 20
    },
    welcomeTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#7C3AED',
        marginBottom: 10,
    },
    welcomeText: {
        fontSize: 15,
        marginBottom: 10,
        color: '#374151',
    },
    buttonGroup: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        marginTop: 15,
    },
    button: {
        paddingVertical: 12,
        paddingHorizontal: 18,
        borderRadius: 8,
        flexDirection: 'row',
        alignItems: 'center',
    },
    buttonText: {
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    button2: { backgroundColor: "#7D57C1", padding: 10, borderRadius: 5, alignItems: "center" },
    buttonText2: { color: "white", fontWeight: "bold" },
});

export default drawerHoc({
    Component: ArchivedOnboards,
});
